import React from 'react'
// Local
import { formatConditionTitleExt } from '../../common/formatUtils'
import AddressedIcon from '../common/addressedIcon'
import ConditionDismissed from '../common/conditionDismissed'
import { EncounterConditionDisplay } from '../../authenticated/types'
import { shouldRenderReskin2025 } from '../../../constant'

/**
 * Provides a component for the clinical admin condition header title.
 *
 * @param mode View mode. Options: null or "smart". Default: null
 * @param active True if condition is currently in active state
 * @param hccChild True if condition is a member of an HCC display group
 * @param hccAddressed True if condition is a member of an HCC display group
 *        and the group is marked as addressed
 * @param condition Condition entity
 * @param onConditionAction Callback for condition action
 *        Arguments: action, condition
 */

type Props = {
  active: boolean
  condition: EncounterConditionDisplay
  hccChild: boolean
}

function ClinicalAdminConditionHeaderTitle(
  props: Props
): JSX.Element {
  const {
    active: isActiveProp,
    condition: conditionProp,
    hccChild: isHCCChild
  } = props
  const isActive = isActiveProp && isActiveProp === true
  const titleText = formatConditionTitleExt(
    conditionProp,
    { hccChild: isHCCChild }
  )
  const conditionTitle = shouldRenderReskin2025
    ? 'condition-title reskin'
    : 'condition-title'
  return (
    <div className="physician-condition-title">
      <div className="flex-title">
        <AddressedIcon condition={ conditionProp } />
        <div className={ conditionTitle }>
          { isActive ? <strong>{ titleText }</strong> : titleText }
        </div>
        <div className="condition-toolbar">
          <ConditionDismissed condition={ conditionProp } />
        </div>
      </div>
    </div>
  )
}

export default ClinicalAdminConditionHeaderTitle
